
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.11797',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.11797",
  "apollo-dlb": "static-3.80",
  "client-types": "static-1.454",
  "dashboard-client-types": "static-1.292",
  "data-fetching-client": "static-1.9549",
  "foundations-components": "static-1.7662",
  "foundations-components-legacy": "static-1.687",
  "foundations-theming": "static-1.4283",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.79",
  "head-dlb": "static-1.4884",
  "hs-test-utils": "static-1.7883",
  "hub-http-shared-msw-handlers": "static-1.9655",
  "hubspot-dlb": "static-2.1806",
  "hubspot-url-utils": "static-1.3957",
  "HubStyleTokens": "static-2.11316",
  "I18n": "static-7.1598",
  "jasmine-runner": "static-1.6343",
  "marketplace-storefront-base": "static-1.11858",
  "quartz": "static-1.6830",
  "react-dlb": "static-1.74",
  "react-rhumb": "static-1.16525",
  "react-router-dom": "static-5.26",
  "reactive-variable-buffer-atom": "static-1.2736",
  "reporting-testing-lib": "static-1.8777",
  "settings-ui-lib": "static-1.12396",
  "SharedI18nStrings": "static-1.181",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.6883",
  "ui-addon-i18n": "static-1.11019",
  "ui-addon-react-router-dom": "static-1.9418",
  "unified-auth": "static-1.308",
  "unified-auth-core-lib": "static-1.589",
  "usage-tracker": "static-1.7209",
  "usage-tracker-core": "static-1.7059",
  "customer-data-property-utils": "static-1.7954",
  "history": "static-4.47",
  "hub-http": "static-1.6092",
  "integrations-lib": "static-1.15657",
  "marketplace-ui-common": "static-1.19173",
  "property-management-iframe": "static-1.12665",
  "quartz-config": "static-1.608",
  "quartz-core": "static-1.6049",
  "quartz-routing": "static-1.260",
  "quick-fetch": "static-1.3807",
  "react": "static-7.182",
  "rpc-client-utils": "static-1.4517",
  "ts-schema": "static-1.3974",
  "ui-universal-auth": "static-1.8794",
  "UIComponents": "static-3.8263",
  "apollo-stack-hubspot": "static-3.79",
  "enviro": "static-4.416",
  "hs-promise-rejection-tracking": "static-1.5433",
  "PortalIdParser": "static-2.377",
  "raven": "static-3.5768",
  "raven-hubspot": "static-1.6075",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.19",
  "metrics-js": "static-1.9436",
  "react-redux": "static-7.67",
  "redux": "static-4.16",
  "styled-components": "static-2.85",
  "bend-plugin-trellis-migration": "static-1.3301",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3107",
  "quartz-webpack": "static-1.3054",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.3931",
  "floating-ui": "static-1.53",
  "foundations-assets": "static-1.4713",
  "foundations-theming-specialty": "static-1.1999",
  "framer-motion": "static-1.69",
  "hs-story-utils": "static-1.9300",
  "react-aria": "static-1.63",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5242",
  "react-virtualized": "static-2.96",
  "StyleGuideUI": "static-3.485",
  "tanstack-table": "static-1.52",
  "trellis-assets": "static-1.1423",
  "ui-fonts": "static-1.578",
  "ui-images": "static-2.1124",
  "bend-plugin-foundations-theming": "static-1.2766",
  "foundations-theming-base": "static-1.3268",
  "stylex": "static-1.29",
  "HeadJS": "static-2.732",
  "hs-test-utils-bend-plugin": "static-1.2994",
  "msw": "static-1.39",
  "testing-library": "static-1.149",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.218",
  "moment-timezone": "static-5.80",
  "jasmine": "static-4.4198",
  "ai-components-ui-library": "static-1.8574",
  "ai-rendering-library": "static-1.9571",
  "chirp-fetch": "static-1.1755",
  "connections-embed-lib": "static-1.738",
  "copilot-toolkit": "static-1.10739",
  "laboratory-lib": "static-3.7033",
  "marketplace-embed": "static-1.21672",
  "marketplace-ui-details": "static-1.9069",
  "marketplace-ui-reviews": "static-1.19129",
  "marketplace-ui-tracking": "static-1.13344",
  "sanitize-text": "static-1.8018",
  "ui-addon-video-player": "static-1.8568",
  "usage-tracker-multi": "static-1.5623",
  "usage-tracker-session-replay": "static-1.4895",
  "wootric-nps": "static-1.6856",
  "apollo-link-hub-http": "static-2.4524",
  "immer": "static-1.33",
  "immerable": "static-1.4026",
  "highcharts": "static-8.101",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2414",
  "reporting-data": "static-1.66844",
  "cssUtils": "static-1.764",
  "flux-actions": "static-1.323",
  "HubStyle": "static-2.11624",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.10083",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10247",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7199",
  "icons": "static-2.637",
  "marketplace-ui-apps-core": "static-1.17706",
  "storybook-react": "static-1.30",
  "trellis-story-utils": "static-1.4393",
  "foundations-components-test-utils": "static-1.5145",
  "quartz-i18n": "static-1.505",
  "react-input-autosize": "static-2.17",
  "fsm": "static-1.3604",
  "customer-data-objects": "static-1.7527",
  "property-translator": "static-1.5281",
  "frontend-preferences-client": "static-1.7797",
  "hs-promise-utils": "static-1.5468",
  "hubspot-apollo-client": "static-1.4752",
  "integrations-error-boundary-lib": "static-1.13072",
  "integrations-tracking-lib": "static-1.5464",
  "native-integrations-shared-strings": "static-1.7659",
  "reselect": "static-2.16",
  "sanitize": "static-1.4347",
  "superstore": "static-1.4641",
  "ui-shepherd-react": "static-3.10019",
  "ai-settings-ui-library": "static-1.7668",
  "hub-http-janus": "static-1.816",
  "hubspotter-http": "static-1.4547",
  "immutable-less": "static-1.4526",
  "marketplace-ui-client-types": "static-1.16580",
  "nav-meta": "static-1.29170",
  "react-window": "static-1.13",
  "self-service-api": "static-1.10115",
  "ui-addon-upgrades": "static-9.17776",
  "inbound-db-properties-service-client": "static-1.3740",
  "property-management-common": "static-1.4953",
  "ui-addon-iframeable": "static-1.8921",
  "dispatcher": "static-1.133",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.506",
  "module-federation": "static-1.20",
  "quartz-auth": "static-1.505",
  "quartz-head": "static-1.495",
  "quartz-test": "static-1.505",
  "quartz-tracking": "static-1.209",
  "csstype": "static-1.50",
  "bender-build-tools": "static-1.3025",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.20651",
  "ContentUtils": "static-1.67853",
  "sassPrefix": "static-1.153",
  "avatar-components": "static-1.2366",
  "customer-data-filters-ui": "static-1.39176",
  "customer-data-objects-ui-components": "static-1.12887",
  "customer-data-reference-ui-components": "static-1.13023",
  "embedded-academy-lib": "static-1.13829",
  "ExportDialog": "static-6.10262",
  "highlight.js": "static-1.76",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.40859",
  "reporting-snowflake": "static-1.55462",
  "reporting-ui-components": "static-2.64115",
  "reporting-visualizations": "static-1.58920",
  "ui-addon-teams": "static-1.21353",
  "magpie-lib": "static-1.5467",
  "magpie-types": "static-1.4927",
  "simple-logging-lib": "static-1.2923",
  "navigation-components": "static-1.17533",
  "ai-studio-lib": "static-1.11205",
  "app-governance-lib": "static-1.1110",
  "developer-experience-shared-components": "static-1.10374",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.7864",
  "ui-product-approvals": "static-1.27713",
  "ui-tool-access": "static-1.10018",
  "usage-based-billing-components-lib": "static-1.8223",
  "usage-tracker-anonymous": "static-1.5626",
  "usage-tracker-public": "static-1.7020",
  "amplitude-session-replay-browser": "static-1.57",
  "inbound-db-meta-service-client": "static-1.3484",
  "persist-promise": "static-1.3582",
  "reference-resolvers": "static-1.8039",
  "ui-extensibility-client-types": "static-1.3814",
  "hubspot-apollo-cache": "static-1.211",
  "universal-page-editor-lib": "static-1.2874",
  "final-form": "static-1.67",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.2386",
  "merchandise-lib": "static-1.261",
  "atom": "static-1.4943",
  "purchase-motions-components": "static-1.5614",
  "salesImages": "static-1.522",
  "batch-promise": "static-1.1425",
  "crm-component-utils": "static-1.38672",
  "crm-properties-common-lib": "static-1.5746",
  "customer-data-properties": "static-1.51031",
  "framework-data-schema-resolvers": "static-1.6747",
  "property-value-citations": "static-1.1645",
  "reference-resolvers-lite": "static-1.7958",
  "navigation-messaging": "static-1.6860",
  "hubspotter-http-shared-msw-handlers": "static-1.9653",
  "cms-field-types": "static-1.4681",
  "content-icons-ui": "static-1.2188",
  "conversations-skeleton-state": "static-1.7121",
  "crm-message-bus": "static-1.42592",
  "customer-data-filters-ui-msw-helpers": "static-1.21611",
  "customer-data-ui-utilities": "static-1.9697",
  "FormUrlGenerator": "static-2.4594",
  "framework-builder-read-service-client": "static-1.3902",
  "framework-data-schema-quick-fetch": "static-1.6652",
  "multi-account-reference-resolvers": "static-1.852",
  "onboarding-tours": "static-1.16368",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.13273",
  "academy-common-lib": "static-1.13289",
  "content-assistance-lib": "static-1.7553",
  "dashboard-lib": "static-1.80938",
  "file-manager-components": "static-1.23158",
  "getting-started-shared-tasks": "static-1.18091",
  "hubspot-prosemirror": "static-1.17824",
  "hubspot-prosemirror-plugins": "static-1.17816",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.19604",
  "share-with-third-party-component-lib": "static-1.8566",
  "ui-addon-draggable": "static-3.4641",
  "ui-asset-management-lib": "static-1.10821",
  "ui-business-units-lib": "static-1.8908",
  "user-context": "static-1.4973",
  "growth-payments-core": "static-1.24939",
  "reporting-plugins": "static-1.10073",
  "reporting-reports": "static-1.66522",
  "idb-keyval": "static-1.41",
  "reactive-lib": "static-1.597",
  "nest": "static-1.94",
  "codemirror": "static-5.92",
  "feedback-loader": "static-1.29025",
  "react-codemirror": "static-1.10498",
  "framework-listing-lib": "static-2.28250",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.30317",
  "apps-service-types": "static-1.3750",
  "oauth-service-types": "static-1.4120",
  "onboarding-scopes": "static-1.6336",
  "onboarding-tours-client": "static-1.4582",
  "platform-infra-nav-components": "static-1.7561",
  "subscription-experience-data-types": "static-1.14683",
  "crm-record-cards-service-types": "static-1.3511",
  "location-customization-utils-lib": "static-1.8794",
  "redux-thunk": "static-2.43",
  "growth-monetization-service-types": "static-1.4371",
  "nav-client-types": "static-1.2230",
  "purchase-motions-api": "static-1.5617",
  "signup-constants": "static-1.18567",
  "signup-ui-url-generator": "static-2.7909",
  "trials-service-types": "static-1.3772",
  "card-properties-lib": "static-1.43737",
  "commerce-subscription-lib": "static-1.36673",
  "crm-actions": "static-1.6183",
  "crm-cards-sdk": "static-1.43149",
  "customer-data-properties-shared-msw-handlers": "static-1.8982",
  "customer-data-tracking": "static-1.6756",
  "hs-entities": "static-1.564",
  "pulse": "static-1.403",
  "calling-global-api": "static-1.63960",
  "calling-internal-common": "static-1.31173",
  "calling-lifecycle-internal": "static-1.65342",
  "calling-lifecycle-messages": "static-1.57636",
  "commerce-products-lib": "static-1.9055",
  "conditional-properties-service-client": "static-1.3692",
  "crm-links": "static-1.6143",
  "external-options-client-types": "static-1.4053",
  "google-libphonenumber": "static-1.35",
  "inbounddb-objects-service-types": "static-1.4117",
  "meetings-icalendar-utils-lib": "static-1.504",
  "multi-currency-client-types": "static-1.3584",
  "object-builder-ui-client": "static-1.48261",
  "pipeline-validation-client-types": "static-1.3858",
  "smart-property-lib": "static-1.6245",
  "tiered-pricing": "static-1.951",
  "ui-addon-form-validation": "static-1.10865",
  "crm-pipelines-api-client-types": "static-1.4036",
  "react-dnd-compat": "static-1.4492",
  "react-immutable-render-mixin": "static-1.9",
  "growth-data-modal": "static-1.5233",
  "growth-onboarding-confetti": "static-1.2945",
  "growth-onboarding-next-action-utils": "static-1.1498",
  "onboarding-tours-utils": "static-1.434",
  "ui-shepherd-tracker": "static-1.7400",
  "academy-service-client": "static-1.3553",
  "zustand": "static-1.51",
  "ui-coaching-tips": "static-1.28145",
  "redux-actions": "static-3.7",
  "ui-addon-opt": "static-4.8257",
  "video-components-external": "static-1.10805",
  "video-data-lib": "static-1.34463",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8431",
  "payment-link-components": "static-1.23136",
  "ui-addon-emoji-picker": "static-1.9760",
  "EmailSignatureEditor": "static-1.24056",
  "viral-links-lib": "static-1.6913",
  "data-token-picker": "static-1.16175",
  "FileManagerLib": "static-1.38798",
  "react-flip-move": "static-1.67",
  "timezone-utils": "static-2.5117",
  "getting-started-shared-tasks-store": "static-1.17209",
  "campaign-roi-lib": "static-1.8509",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "customer-data-associations": "static-1.7195",
  "customer-data-views-management": "static-1.25144",
  "framework-data-table": "static-2.11597",
  "marketing-platform-lib": "static-1.6719",
  "nudge-client-utils": "static-1.2301",
  "nudge-custom-ui-functions": "static-1.802",
  "app-users-service-client": "static-1.5419",
  "app-users-service-types": "static-1.4827",
  "mini-checkout-client": "static-1.26496",
  "onboarding-utils": "static-1.5224",
  "permissions-shared-i18n-strings-fe": "static-1.1975",
  "ui-coaching-tips-shared-config": "static-1.28130",
  "edison-service-client-types": "static-1.265",
  "eligibility-engine-service-types": "static-1.3053",
  "crm_data": "static-4.91495",
  "customer-data-sidebar": "static-2.45621",
  "enrichment-properties-lib": "static-1.15363",
  "commerce-billing-lib": "static-1.18697",
  "commerce-shared-components-lib": "static-1.18158",
  "commerce-tools-ui-lib": "static-1.9995",
  "crm-fe-perf": "static-1.22776",
  "hs-resources": "static-1.6",
  "directed-graph": "static-1.811",
  "event-emitter": "static-1.820",
  "fast-json-patch": "static-1.60",
  "calling-error-reporting": "static-1.31179",
  "shared-worker-versioning": "static-1.10912",
  "calling-usage-tracker": "static-1.6414",
  "voice-sms-access-library": "static-1.465",
  "commerce-permissions": "static-1.637",
  "products-iframe-lib": "static-1.7541",
  "products-ui-components-shared-msw-handlers": "static-1.10037",
  "breeze-intelligence-kit": "static-1.5426",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9738",
  "policy-lib": "static-1.6652",
  "react-tinymce": "static-1.54836",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9801",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.53962",
  "tinymce-plugins": "static-1.57076",
  "tinymce-themes": "static-1.55932",
  "growth-onboarding-next-action-components": "static-1.1526",
  "user-context-client": "static-1.4485",
  "growth-onboarding-feedback-components": "static-1.6454",
  "content-media-composition-data-lib": "static-1.11753",
  "content-media-compositions": "static-2.15760",
  "media-bridge-lib": "static-1.18698",
  "commerce-tours-lib": "static-1.5844",
  "growth-onboarding-reliability": "static-1.4959",
  "sales-checkout-service-client": "static-1.3541",
  "draft-convert": "static-2.70",
  "draft-extend": "static-3.72",
  "draft-js": "static-5.75",
  "draft-plugins": "static-2.21442",
  "sales-email-signature-service-client": "static-1.3716",
  "audio-components": "static-1.5716",
  "FileManagerCore": "static-1.38657",
  "FileManagerImages": "static-1.36309",
  "video-components": "static-1.12808",
  "crm-export-dialog": "static-1.6167",
  "crm-index-associations-lib": "static-1.6308",
  "react-beautiful-dnd": "static-1.13",
  "deal-intel-decorators": "static-1.1512",
  "tanstack-virtual": "static-1.27",
  "nudge-custom-function-registry": "static-1.2058",
  "nudge-renderer-utils": "static-1.2377",
  "whisper-core-api": "static-1.6197",
  "InboxConnectUtils": "static-4.14426",
  "emoji-regex": "static-1.7",
  "touchless-buying-components": "static-1.5228",
  "settings-content-modals": "static-1.45674",
  "crm_universal": "static-1.21777",
  "customer-data-email": "static-1.17802",
  "card-payment-highlight-lib": "static-1.36725",
  "card-subscription-highlight-lib": "static-1.39096",
  "commerce-contract-lib": "static-1.11472",
  "invoices-highlight-card-lib": "static-1.54262",
  "orders-highlight-card-lib": "static-1.21068",
  "products-highlight-card-lib": "static-1.17339",
  "quotes-highlight-card-lib": "static-1.71453",
  "crm-source-interpretation-lib": "static-1.5204",
  "utility-belt": "static-1.2413",
  "payments-enrollment-embed-lib": "static-1.22222",
  "customer-data-rte": "static-1.32633",
  "cv-backend-services": "static-1.1529",
  "growth-onboarding-empty-states": "static-1.5477",
  "payments-post-enroll-local-storage-lib": "static-1.4986",
  "qrcode-generator": "static-1.66",
  "quotes-client-types": "static-1.37543",
  "calling-orchestration-schema": "static-1.35242",
  "sales-views-client-types": "static-1.4136",
  "hub-http-contrib": "static-1.2916",
  "interframe": "static-3.4635",
  "tinymce-data": "static-1.40047",
  "ui-addon-sales-email": "static-1.5086",
  "layout-dnd-components": "static-1.12190",
  "layout-dnd-utils": "static-1.11165",
  "ui-brand-identity-lib": "static-1.14426",
  "NamespacedHubStyle": "static-2.8963",
  "js-cookie": "static-1.18",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4405",
  "video-embed": "static-1.35297",
  "social-insights-client-types": "static-1.21619",
  "deal-intel-utils": "static-1.1516",
  "checkout-sdk": "static-3.23339",
  "checkout-service-types": "static-1.3720",
  "company-details-components": "static-1.6059",
  "payment-method-components": "static-1.6767",
  "pricing-pages-ui-components": "static-1.13037",
  "quote-checkout-service-types": "static-1.3355",
  "upgrade-catalog-service-types": "static-1.3399",
  "access-control-lib": "static-1.10310",
  "EmailComponents": "static-1.54351",
  "EmailData": "static-1.53028",
  "redux-less": "static-2.9358",
  "sequences-lib": "static-1.7815",
  "ui-gdpr-components": "static-1.10221",
  "products-ui-components": "static-1.39574",
  "quotes-ui-lib": "static-1.80174",
  "accounting-integrations-ui-components": "static-1.6853",
  "invoices-ui-lib": "static-1.54278",
  "commerce-products-api": "static-1.2077",
  "invoices-iframe-lib": "static-1.56336",
  "quotes-modal-lib": "static-1.102131",
  "stripe-embedded-components": "static-1.7274",
  "draft-content-plugins": "static-1.27901",
  "ContentData": "static-1.67928",
  "layout-data-lib": "static-1.9490",
  "outpost": "static-1.4071",
  "hub-http-rxjs": "static-1.782",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "company-details-service-types": "static-1.3802",
  "billing-payments-client-types": "static-1.3861",
  "account-and-billing-fintech-outages": "static-3.18337",
  "pricing-pages-api": "static-1.12902",
  "ContentComponents": "static-2.70809",
  "marketing-contacts-lib": "static-1.9380",
  "marketing-email-service-types": "static-1.1822",
  "messaging-editing-lib": "static-1.45835",
  "messaging-usage-based-billing-components-lib": "static-1.697",
  "automation-ui-source-apps": "static-1.18445",
  "automation-ui-types": "static-1.19363",
  "messaging-types-lib": "static-1.45572",
  "onboarding-settings-client": "static-1.4377",
  "sequences-client-types-lib": "static-1.7672",
  "commerce-tax-lib": "static-1.391",
  "property-description-translator": "static-1.3727",
  "commerce-analytics-service-client": "static-1.3529",
  "totals-ui-components": "static-1.23190",
  "stripe-connect-js": "static-1.66",
  "advanced-menus-core": "static-1.14923",
  "advanced-menus-lib": "static-1.11889",
  "ui-memberships-settings-lib": "static-1.33653",
  "demographics-service-types": "static-1.1521",
  "automation-ui-ubb": "static-1.5279",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7213",
  "data-token-views": "static-1.16156",
  "forms-utils-lib": "static-1.12321",
  "payments-embed-points-lib": "static-1.12759",
  "simple-menus-core": "static-1.14922",
  "simple-menus-lib": "static-1.16439",
  "ui-addon-draggable-compat": "static-2.4127",
  "videoconference-integration-components": "static-1.6633",
  "automation-applications-service-types": "static-1.3399",
  "automation-platform-service-types": "static-1.2544",
  "ContentEditorUI": "static-2.76738",
  "short-messages-app-service-client": "static-1.3867",
  "web-interactives-components": "static-1.13533",
  "web-interactives-data": "static-1.13534",
  "messaging-shared-utils-lib": "static-1.146",
  "messaging-user-info-utils-lib": "static-1.316",
  "email-portal-health-service-types": "static-1.849",
  "commerce-totals-service-types": "static-1.3710",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.21299",
  "automation-ui-usage-tracking": "static-1.20762",
  "data-studio-ubb": "static-1.2317",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.26624",
  "collaboration-sidebar": "static-1.57341",
  "content-management-data-lib": "static-1.5215",
  "copilot-plugins": "static-1.10712",
  "cta-picker": "static-1.36033",
  "customer-agent-discovery-components-lib": "static-1.2648",
  "editor-components": "static-1.13039",
  "editor-iframe-lib": "static-1.8219",
  "error-messaging-js": "static-1.5063",
  "FireAlarmUi": "static-1.4403",
  "FormsCommonComponents": "static-1.85477",
  "pictos": "static-7.181",
  "react-transition-group": "static-2.62",
  "redux-request-state": "static-1.10518",
  "SharedLegalStrings": "static-1.1625",
  "smart-content-core": "static-1.42058",
  "smart-content-lib": "static-1.42711",
  "social-composer-lib": "static-1.58434",
  "structured-content-lib": "static-1.24815",
  "theme-previewer-lib": "static-1.52885",
  "tinymce-copilot": "static-1.16030",
  "xray-recommendation-lib": "static-1.7701",
  "automation-ui-routing": "static-1.20720",
  "sql-reporting-client-types": "static-1.5536",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.41841",
  "campaigns-utils-lib": "static-1.3028",
  "reporting-enablement": "static-1.22356",
  "chatspot-widget-iframe": "static-1.20643",
  "collaboration-sidebar-common": "static-1.2138",
  "forms-ai-lib": "static-1.4113",
  "codemirror-dlb": "static-1.58297",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6301",
  "report-customization-components": "static-1.12735",
  "data-quality-ui-library": "static-1.12515",
  "html-to-image": "static-1.51",
  "reporting-insights-lib": "static-1.1289"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.11797",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "client-types": "/client-types/static-1.454",
  "dashboard-client-types": "/dashboard-client-types/static-1.292",
  "data-fetching-client": "/data-fetching-client/static-1.9549",
  "foundations-components": "/foundations-components/static-1.7662",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.687",
  "foundations-theming": "/foundations-theming/static-1.4283",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.79",
  "head-dlb": "/head-dlb/static-1.4884",
  "hs-test-utils": "/hs-test-utils/static-1.7883",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9655",
  "hubspot-dlb": "/hubspot-dlb/static-2.1806",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3957",
  "HubStyleTokens": "/HubStyleTokens/static-2.11316",
  "I18n": "/I18n/static-7.1598",
  "jasmine-runner": "/jasmine-runner/static-1.6343",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.11858",
  "quartz": "/quartz/static-1.6830",
  "react-dlb": "/react-dlb/static-1.74",
  "react-rhumb": "/react-rhumb/static-1.16525",
  "react-router-dom": "/react-router-dom/static-5.26",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2736",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8777",
  "settings-ui-lib": "/settings-ui-lib/static-1.12396",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.181",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.6883",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11019",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9418",
  "unified-auth": "/unified-auth/static-1.308",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.589",
  "usage-tracker": "/usage-tracker/static-1.7209",
  "usage-tracker-core": "/usage-tracker-core/static-1.7059",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7954",
  "history": "/history/static-4.47",
  "hub-http": "/hub-http/static-1.6092",
  "integrations-lib": "/integrations-lib/static-1.15657",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.19173",
  "property-management-iframe": "/property-management-iframe/static-1.12665",
  "quartz-config": "/quartz-config/static-1.608",
  "quartz-core": "/quartz-core/static-1.6049",
  "quartz-routing": "/quartz-routing/static-1.260",
  "quick-fetch": "/quick-fetch/static-1.3807",
  "react": "/react/static-7.182",
  "rpc-client-utils": "/rpc-client-utils/static-1.4517",
  "ts-schema": "/ts-schema/static-1.3974",
  "ui-universal-auth": "/ui-universal-auth/static-1.8794",
  "UIComponents": "/UIComponents/static-3.8263",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.79",
  "enviro": "/enviro/static-4.416",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5433",
  "PortalIdParser": "/PortalIdParser/static-2.377",
  "raven": "/raven/static-3.5768",
  "raven-hubspot": "/raven-hubspot/static-1.6075",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.19",
  "metrics-js": "/metrics-js/static-1.9436",
  "react-redux": "/react-redux/static-7.67",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.85",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3301",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3107",
  "quartz-webpack": "/quartz-webpack/static-1.3054",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3931",
  "floating-ui": "/floating-ui/static-1.53",
  "foundations-assets": "/foundations-assets/static-1.4713",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1999",
  "framer-motion": "/framer-motion/static-1.69",
  "hs-story-utils": "/hs-story-utils/static-1.9300",
  "react-aria": "/react-aria/static-1.63",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5242",
  "react-virtualized": "/react-virtualized/static-2.96",
  "StyleGuideUI": "/StyleGuideUI/static-3.485",
  "tanstack-table": "/tanstack-table/static-1.52",
  "trellis-assets": "/trellis-assets/static-1.1423",
  "ui-fonts": "/ui-fonts/static-1.578",
  "ui-images": "/ui-images/static-2.1124",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2766",
  "foundations-theming-base": "/foundations-theming-base/static-1.3268",
  "stylex": "/stylex/static-1.29",
  "HeadJS": "/HeadJS/static-2.732",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2994",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.149",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.218",
  "moment-timezone": "/moment-timezone/static-5.80",
  "jasmine": "/jasmine/static-4.4198",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8574",
  "ai-rendering-library": "/ai-rendering-library/static-1.9571",
  "chirp-fetch": "/chirp-fetch/static-1.1755",
  "connections-embed-lib": "/connections-embed-lib/static-1.738",
  "copilot-toolkit": "/copilot-toolkit/static-1.10739",
  "laboratory-lib": "/laboratory-lib/static-3.7033",
  "marketplace-embed": "/marketplace-embed/static-1.21672",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.9069",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.19129",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.13344",
  "sanitize-text": "/sanitize-text/static-1.8018",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8568",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5623",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4895",
  "wootric-nps": "/wootric-nps/static-1.6856",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4524",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4026",
  "highcharts": "/highcharts/static-8.101",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2414",
  "reporting-data": "/reporting-data/static-1.66844",
  "cssUtils": "/cssUtils/static-1.764",
  "flux-actions": "/flux-actions/static-1.323",
  "HubStyle": "/HubStyle/static-2.11624",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.10083",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10247",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7199",
  "icons": "/icons/static-2.637",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.17706",
  "storybook-react": "/storybook-react/static-1.30",
  "trellis-story-utils": "/trellis-story-utils/static-1.4393",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5145",
  "quartz-i18n": "/quartz-i18n/static-1.505",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "fsm": "/fsm/static-1.3604",
  "customer-data-objects": "/customer-data-objects/static-1.7527",
  "property-translator": "/property-translator/static-1.5281",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7797",
  "hs-promise-utils": "/hs-promise-utils/static-1.5468",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4752",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13072",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5464",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7659",
  "reselect": "/reselect/static-2.16",
  "sanitize": "/sanitize/static-1.4347",
  "superstore": "/superstore/static-1.4641",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10019",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7668",
  "hub-http-janus": "/hub-http-janus/static-1.816",
  "hubspotter-http": "/hubspotter-http/static-1.4547",
  "immutable-less": "/immutable-less/static-1.4526",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.16580",
  "nav-meta": "/nav-meta/static-1.29170",
  "react-window": "/react-window/static-1.13",
  "self-service-api": "/self-service-api/static-1.10115",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17776",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3740",
  "property-management-common": "/property-management-common/static-1.4953",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8921",
  "dispatcher": "/dispatcher/static-1.133",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.506",
  "module-federation": "/module-federation/static-1.20",
  "quartz-auth": "/quartz-auth/static-1.505",
  "quartz-head": "/quartz-head/static-1.495",
  "quartz-test": "/quartz-test/static-1.505",
  "quartz-tracking": "/quartz-tracking/static-1.209",
  "csstype": "/csstype/static-1.50",
  "bender-build-tools": "/bender-build-tools/static-1.3025",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.20651",
  "ContentUtils": "/ContentUtils/static-1.67853",
  "sassPrefix": "/sassPrefix/static-1.153",
  "avatar-components": "/avatar-components/static-1.2366",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39176",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12887",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13023",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.13829",
  "ExportDialog": "/ExportDialog/static-6.10262",
  "highlight.js": "/highlight.js/static-1.76",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.40859",
  "reporting-snowflake": "/reporting-snowflake/static-1.55462",
  "reporting-ui-components": "/reporting-ui-components/static-2.64115",
  "reporting-visualizations": "/reporting-visualizations/static-1.58920",
  "ui-addon-teams": "/ui-addon-teams/static-1.21353",
  "magpie-lib": "/magpie-lib/static-1.5467",
  "magpie-types": "/magpie-types/static-1.4927",
  "simple-logging-lib": "/simple-logging-lib/static-1.2923",
  "navigation-components": "/navigation-components/static-1.17533",
  "ai-studio-lib": "/ai-studio-lib/static-1.11205",
  "app-governance-lib": "/app-governance-lib/static-1.1110",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10374",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7864",
  "ui-product-approvals": "/ui-product-approvals/static-1.27713",
  "ui-tool-access": "/ui-tool-access/static-1.10018",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.8223",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5626",
  "usage-tracker-public": "/usage-tracker-public/static-1.7020",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.57",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3484",
  "persist-promise": "/persist-promise/static-1.3582",
  "reference-resolvers": "/reference-resolvers/static-1.8039",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3814",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.211",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2874",
  "final-form": "/final-form/static-1.67",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.2386",
  "merchandise-lib": "/merchandise-lib/static-1.261",
  "atom": "/atom/static-1.4943",
  "purchase-motions-components": "/purchase-motions-components/static-1.5614",
  "salesImages": "/salesImages/static-1.522",
  "batch-promise": "/batch-promise/static-1.1425",
  "crm-component-utils": "/crm-component-utils/static-1.38672",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5746",
  "customer-data-properties": "/customer-data-properties/static-1.51031",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6747",
  "property-value-citations": "/property-value-citations/static-1.1645",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7958",
  "navigation-messaging": "/navigation-messaging/static-1.6860",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9653",
  "cms-field-types": "/cms-field-types/static-1.4681",
  "content-icons-ui": "/content-icons-ui/static-1.2188",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7121",
  "crm-message-bus": "/crm-message-bus/static-1.42592",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21611",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9697",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4594",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3902",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6652",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.852",
  "onboarding-tours": "/onboarding-tours/static-1.16368",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13273",
  "academy-common-lib": "/academy-common-lib/static-1.13289",
  "content-assistance-lib": "/content-assistance-lib/static-1.7553",
  "dashboard-lib": "/dashboard-lib/static-1.80938",
  "file-manager-components": "/file-manager-components/static-1.23158",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18091",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17824",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17816",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.19604",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8566",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4641",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10821",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8908",
  "user-context": "/user-context/static-1.4973",
  "growth-payments-core": "/growth-payments-core/static-1.24939",
  "reporting-plugins": "/reporting-plugins/static-1.10073",
  "reporting-reports": "/reporting-reports/static-1.66522",
  "idb-keyval": "/idb-keyval/static-1.41",
  "reactive-lib": "/reactive-lib/static-1.597",
  "nest": "/nest/static-1.94",
  "codemirror": "/codemirror/static-5.92",
  "feedback-loader": "/feedback-loader/static-1.29025",
  "react-codemirror": "/react-codemirror/static-1.10498",
  "framework-listing-lib": "/framework-listing-lib/static-2.28250",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.30317",
  "apps-service-types": "/apps-service-types/static-1.3750",
  "oauth-service-types": "/oauth-service-types/static-1.4120",
  "onboarding-scopes": "/onboarding-scopes/static-1.6336",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4582",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7561",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14683",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3511",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8794",
  "redux-thunk": "/redux-thunk/static-2.43",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4371",
  "nav-client-types": "/nav-client-types/static-1.2230",
  "purchase-motions-api": "/purchase-motions-api/static-1.5617",
  "signup-constants": "/signup-constants/static-1.18567",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7909",
  "trials-service-types": "/trials-service-types/static-1.3772",
  "card-properties-lib": "/card-properties-lib/static-1.43737",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.36673",
  "crm-actions": "/crm-actions/static-1.6183",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.43149",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.8982",
  "customer-data-tracking": "/customer-data-tracking/static-1.6756",
  "hs-entities": "/hs-entities/static-1.564",
  "pulse": "/pulse/static-1.403",
  "calling-global-api": "/calling-global-api/static-1.63960",
  "calling-internal-common": "/calling-internal-common/static-1.31173",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65342",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57636",
  "commerce-products-lib": "/commerce-products-lib/static-1.9055",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3692",
  "crm-links": "/crm-links/static-1.6143",
  "external-options-client-types": "/external-options-client-types/static-1.4053",
  "google-libphonenumber": "/google-libphonenumber/static-1.35",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4117",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.504",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3584",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48261",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3858",
  "smart-property-lib": "/smart-property-lib/static-1.6245",
  "tiered-pricing": "/tiered-pricing/static-1.951",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10865",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4036",
  "react-dnd-compat": "/react-dnd-compat/static-1.4492",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "growth-data-modal": "/growth-data-modal/static-1.5233",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2945",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1498",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.434",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7400",
  "academy-service-client": "/academy-service-client/static-1.3553",
  "zustand": "/zustand/static-1.51",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28145",
  "redux-actions": "/redux-actions/static-3.7",
  "ui-addon-opt": "/ui-addon-opt/static-4.8257",
  "video-components-external": "/video-components-external/static-1.10805",
  "video-data-lib": "/video-data-lib/static-1.34463",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8431",
  "payment-link-components": "/payment-link-components/static-1.23136",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9760",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24056",
  "viral-links-lib": "/viral-links-lib/static-1.6913",
  "data-token-picker": "/data-token-picker/static-1.16175",
  "FileManagerLib": "/FileManagerLib/static-1.38798",
  "react-flip-move": "/react-flip-move/static-1.67",
  "timezone-utils": "/timezone-utils/static-2.5117",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17209",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8509",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "customer-data-associations": "/customer-data-associations/static-1.7195",
  "customer-data-views-management": "/customer-data-views-management/static-1.25144",
  "framework-data-table": "/framework-data-table/static-2.11597",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.6719",
  "nudge-client-utils": "/nudge-client-utils/static-1.2301",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.802",
  "app-users-service-client": "/app-users-service-client/static-1.5419",
  "app-users-service-types": "/app-users-service-types/static-1.4827",
  "mini-checkout-client": "/mini-checkout-client/static-1.26496",
  "onboarding-utils": "/onboarding-utils/static-1.5224",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.1975",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.28130",
  "edison-service-client-types": "/edison-service-client-types/static-1.265",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3053",
  "crm_data": "/crm_data/static-4.91495",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.45621",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.15363",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.18697",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18158",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.9995",
  "crm-fe-perf": "/crm-fe-perf/static-1.22776",
  "hs-resources": "/hs-resources/static-1.6",
  "directed-graph": "/directed-graph/static-1.811",
  "event-emitter": "/event-emitter/static-1.820",
  "fast-json-patch": "/fast-json-patch/static-1.60",
  "calling-error-reporting": "/calling-error-reporting/static-1.31179",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10912",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6414",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.465",
  "commerce-permissions": "/commerce-permissions/static-1.637",
  "products-iframe-lib": "/products-iframe-lib/static-1.7541",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10037",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5426",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9738",
  "policy-lib": "/policy-lib/static-1.6652",
  "react-tinymce": "/react-tinymce/static-1.54836",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9801",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.53962",
  "tinymce-plugins": "/tinymce-plugins/static-1.57076",
  "tinymce-themes": "/tinymce-themes/static-1.55932",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1526",
  "user-context-client": "/user-context-client/static-1.4485",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6454",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11753",
  "content-media-compositions": "/content-media-compositions/static-2.15760",
  "media-bridge-lib": "/media-bridge-lib/static-1.18698",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5844",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4959",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3541",
  "draft-convert": "/draft-convert/static-2.70",
  "draft-extend": "/draft-extend/static-3.72",
  "draft-js": "/draft-js/static-5.75",
  "draft-plugins": "/draft-plugins/static-2.21442",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3716",
  "audio-components": "/audio-components/static-1.5716",
  "FileManagerCore": "/FileManagerCore/static-1.38657",
  "FileManagerImages": "/FileManagerImages/static-1.36309",
  "video-components": "/video-components/static-1.12808",
  "crm-export-dialog": "/crm-export-dialog/static-1.6167",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6308",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.13",
  "deal-intel-decorators": "/deal-intel-decorators/static-1.1512",
  "tanstack-virtual": "/tanstack-virtual/static-1.27",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2058",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.2377",
  "whisper-core-api": "/whisper-core-api/static-1.6197",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14426",
  "emoji-regex": "/emoji-regex/static-1.7",
  "touchless-buying-components": "/touchless-buying-components/static-1.5228",
  "settings-content-modals": "/settings-content-modals/static-1.45674",
  "crm_universal": "/crm_universal/static-1.21777",
  "customer-data-email": "/customer-data-email/static-1.17802",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.36725",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.39096",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.11472",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.54262",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.21068",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.17339",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.71453",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5204",
  "utility-belt": "/utility-belt/static-1.2413",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.22222",
  "customer-data-rte": "/customer-data-rte/static-1.32633",
  "cv-backend-services": "/cv-backend-services/static-1.1529",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5477",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.4986",
  "qrcode-generator": "/qrcode-generator/static-1.66",
  "quotes-client-types": "/quotes-client-types/static-1.37543",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35242",
  "sales-views-client-types": "/sales-views-client-types/static-1.4136",
  "hub-http-contrib": "/hub-http-contrib/static-1.2916",
  "interframe": "/interframe/static-3.4635",
  "tinymce-data": "/tinymce-data/static-1.40047",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5086",
  "layout-dnd-components": "/layout-dnd-components/static-1.12190",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11165",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.14426",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8963",
  "js-cookie": "/js-cookie/static-1.18",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4405",
  "video-embed": "/video-embed/static-1.35297",
  "social-insights-client-types": "/social-insights-client-types/static-1.21619",
  "deal-intel-utils": "/deal-intel-utils/static-1.1516",
  "checkout-sdk": "/checkout-sdk/static-3.23339",
  "checkout-service-types": "/checkout-service-types/static-1.3720",
  "company-details-components": "/company-details-components/static-1.6059",
  "payment-method-components": "/payment-method-components/static-1.6767",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.13037",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3355",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3399",
  "access-control-lib": "/access-control-lib/static-1.10310",
  "EmailComponents": "/EmailComponents/static-1.54351",
  "EmailData": "/EmailData/static-1.53028",
  "redux-less": "/redux-less/static-2.9358",
  "sequences-lib": "/sequences-lib/static-1.7815",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10221",
  "products-ui-components": "/products-ui-components/static-1.39574",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.80174",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.6853",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.54278",
  "commerce-products-api": "/commerce-products-api/static-1.2077",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.56336",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.102131",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7274",
  "draft-content-plugins": "/draft-content-plugins/static-1.27901",
  "ContentData": "/ContentData/static-1.67928",
  "layout-data-lib": "/layout-data-lib/static-1.9490",
  "outpost": "/outpost/static-1.4071",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.782",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "company-details-service-types": "/company-details-service-types/static-1.3802",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.3861",
  "account-and-billing-fintech-outages": "/account-and-billing-fintech-outages/static-3.18337",
  "pricing-pages-api": "/pricing-pages-api/static-1.12902",
  "ContentComponents": "/ContentComponents/static-2.70809",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.9380",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.1822",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.45835",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.697",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.18445",
  "automation-ui-types": "/automation-ui-types/static-1.19363",
  "messaging-types-lib": "/messaging-types-lib/static-1.45572",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4377",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7672",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.391",
  "property-description-translator": "/property-description-translator/static-1.3727",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3529",
  "totals-ui-components": "/totals-ui-components/static-1.23190",
  "stripe-connect-js": "/stripe-connect-js/static-1.66",
  "advanced-menus-core": "/advanced-menus-core/static-1.14923",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11889",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33653",
  "demographics-service-types": "/demographics-service-types/static-1.1521",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.5279",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7213",
  "data-token-views": "/data-token-views/static-1.16156",
  "forms-utils-lib": "/forms-utils-lib/static-1.12321",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.12759",
  "simple-menus-core": "/simple-menus-core/static-1.14922",
  "simple-menus-lib": "/simple-menus-lib/static-1.16439",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4127",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.6633",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3399",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2544",
  "ContentEditorUI": "/ContentEditorUI/static-2.76738",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.3867",
  "web-interactives-components": "/web-interactives-components/static-1.13533",
  "web-interactives-data": "/web-interactives-data/static-1.13534",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.146",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.316",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.849",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3710",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.21299",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.20762",
  "data-studio-ubb": "/data-studio-ubb/static-1.2317",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.26624",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.57341",
  "content-management-data-lib": "/content-management-data-lib/static-1.5215",
  "copilot-plugins": "/copilot-plugins/static-1.10712",
  "cta-picker": "/cta-picker/static-1.36033",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.2648",
  "editor-components": "/editor-components/static-1.13039",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8219",
  "error-messaging-js": "/error-messaging-js/static-1.5063",
  "FireAlarmUi": "/FireAlarmUi/static-1.4403",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85477",
  "pictos": "/pictos/static-7.181",
  "react-transition-group": "/react-transition-group/static-2.62",
  "redux-request-state": "/redux-request-state/static-1.10518",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1625",
  "smart-content-core": "/smart-content-core/static-1.42058",
  "smart-content-lib": "/smart-content-lib/static-1.42711",
  "social-composer-lib": "/social-composer-lib/static-1.58434",
  "structured-content-lib": "/structured-content-lib/static-1.24815",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.52885",
  "tinymce-copilot": "/tinymce-copilot/static-1.16030",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.7701",
  "automation-ui-routing": "/automation-ui-routing/static-1.20720",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5536",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.41841",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3028",
  "reporting-enablement": "/reporting-enablement/static-1.22356",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.20643",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.2138",
  "forms-ai-lib": "/forms-ai-lib/static-1.4113",
  "codemirror-dlb": "/codemirror-dlb/static-1.58297",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6301",
  "report-customization-components": "/report-customization-components/static-1.12735",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12515",
  "html-to-image": "/html-to-image/static-1.51",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1289"
}
};
